import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import { io } from 'socket.io-client';
import MainLayout from '../../components/layouts/MainLayout';
import Header from "../../components/shared/Header";
import Bottomber from "../../components/shared/Bottomber";
import Breadcrumb from '../../components/shared/Breadcrumbs';


const ChatPage = () => {
  const {chatRoomId, minUserId, maxUserId} = useParams();
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);
  const [opponent, setOpponent] = useState(null);
  const backUrl = process.env.REACT_APP_API_URL;


  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "メッセージ一覧", path: "/chat-list" },
    { label: "メッセージ", path: "/chat/:chatRoomId/:minUserId/:maxUserId/" },
  ];

  

  // const userId = localStorage.getItem('userid');

  // const opponentId = userId === minUserId ? maxUserId : minUserId;

  useEffect(() => {
    const token = localStorage.getItem('token');
    const newSocket = new WebSocket(`wss://goldcoast-koala.com/chat/${chatRoomId}/${minUserId}/${maxUserId}/?token=${token}`);
    // const newSocket = new WebSocket(`ws://localhost:8000/chat/${chatRoomId}/${minUserId}/${maxUserId}/?token=${token}`);
    newSocket.onopen = () => {
      console.log("Connected to WebSocket");
      setConnected(true);
    };
  
    newSocket.onclose = () => {
      console.log("Disconnected from WebSocket");
      setConnected(false);
    };
  
    newSocket.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    setSocket(newSocket);
    
    newSocket.onmessage = (e) => {
      const data = JSON.parse(e.data);
      if (data.past_messages) {
        setMessages((prevMessages) => [
          ...prevMessages,
          ...data.past_messages.map((data) => ({
            sender: data.sender,
            message: data.message
          })),
        ]);
      }
      if (data.message && data.sender) {
        setMessages((prevMessages) => [
          ...prevMessages,
          { sender: data.sender, message: data.message },
        ]);
      }
      if (data.opponent) {
        setOpponent(data.opponent[0])
        console.log(data.opponent[0])
      }
      // setMessages((prevMessages) => [...prevMessages, data.message]);
    };
    return () => {
      newSocket.close();
    };

  }, [chatRoomId, maxUserId, minUserId]);

  const handleSendMessage = async () => {
    if (socket && message) {
      setMessages((prevMessages) => [
        ...prevMessages,
        { sender: "self", message }, // 'self' を送信者としてマーク（自分のメッセージ）
      ]);
  
      socket.send(JSON.stringify({ message }));
  
      setMessage(""); // メッセージ送信後にフォームをクリア
    }
  };
  let opponentImg;
  if (opponent && opponent.img && opponent.img !== "None") {
    opponentImg = opponent.img;
  } else {
    opponentImg = '/media/none_user.svg';
  }

  useEffect(() => {
    window.scrollTo(0, document.documentElement.scrollHeight);
  }, [messages]);

  return (
    <div>
    <Header />
    {/* <Breadcrumb items={breadcrumbs} /> */}
    <div className="chat">
      
      <div className="chat__user">
        {opponent ? (
        <>
          <img src={opponentImg} alt="Opponent" />
          <h3>{opponent.username}</h3>
        </>
        ) : (
          <p>Loading...</p>
        )}
      </div>

      <div className="chat__cont">
        <ul>
          {messages.map((data, index) => (
            data.sender === opponent.id ?(
              <>
              <img className="chat__cont-img" src={opponentImg} alt="Opponent" />
              <li className="chat__cont-child left" id={data.sender} key={index}>
                {data.message}
              </li>
              </>
            ):(
              <li className="chat__cont-child right" id={data.sender} key={index}>
                {data.message}
              </li>
            )
          ))}
        </ul>
      </div>
      <div className="chat__sender">
      <input
        type="text"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Type a message"
      />
      <button onClick={handleSendMessage}>Send</button>
      </div>
  </div>
  <Bottomber />
  </div>
  );
};

export default ChatPage;
